import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, LinkedinLogo, WhatsappLogo, ArrowUpRight } from "@phosphor-icons/react";
import { BRAND, NAV } from "../data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1918] text-[#FAF9F6] mt-32">
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-24">
        {/* Info grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.25em] text-[#EB0D0D] mb-4">Koreko Direct</div>
            <p className="text-[#FAF9F6]/60 max-w-md leading-relaxed">
              Showroom e installazione di infissi, vetrate, pergole e impianti fotovoltaici nel Lazio. Concessionario ufficiale Korus.
            </p>

            <div className="flex gap-3 mt-8">
              <a data-testid="social-instagram" href="https://www.instagram.com/koreko_direct_infissi9/" aria-label="Instagram" className="w-11 h-11 border border-[#FAF9F6]/20 hover:border-[#EB0D0D] hover:bg-[#EB0D0D] flex items-center justify-center transition-all rounded-sm">
                <InstagramLogo size={18} />
              </a>
              <a data-testid="social-facebook" href="https://www.facebook.com/p/Korko-direct-100054494917966" aria-label="Facebook" className="w-11 h-11 border border-[#FAF9F6]/20 hover:border-[#EB0D0D] hover:bg-[#EB0D0D] flex items-center justify-center transition-all rounded-sm">
                <FacebookLogo size={18} />
              </a>
              <a data-testid="social-linkedin" href="https://it.linkedin.com/company/kor-ko-green" aria-label="LinkedIn" className="w-11 h-11 border border-[#FAF9F6]/20 hover:border-[#EB0D0D] hover:bg-[#EB0D0D] flex items-center justify-center transition-all rounded-sm">
                <LinkedinLogo size={18} />
              </a>
              <a data-testid="social-whatsapp" href={BRAND.whatsapp} aria-label="WhatsApp" className="w-11 h-11 border border-[#FAF9F6]/20 hover:border-[#EB0D0D] hover:bg-[#EB0D0D] flex items-center justify-center transition-all rounded-sm">
                <WhatsappLogo size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#EB0D0D] mb-5">Naviga</div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-[#FAF9F6]/80 hover:text-[#FAF9F6] transition-colors text-sm">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-[#EB0D0D] mb-5">Contatti</div>
            <ul className="space-y-3 text-sm">
              <li className="text-[#FAF9F6]/80">{BRAND.address}</li>
              <li className="text-[#FAF9F6]/80">{BRAND.region}</li>
              <li>
                <a href={`tel:${BRAND.phoneClean}`} className="text-[#FAF9F6] hover:text-[#EB0D0D] transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="text-[#FAF9F6] hover:text-[#EB0D0D] transition-colors">
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FAF9F6]/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-[#FAF9F6]/50">
          <div>© {new Date().getFullYear()} Koreko Direct · P.IVA · Tutti i diritti riservati</div>
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#FAF9F6] transition-colors">Privacy Policy</Link>
            <Link to="/termini-condizioni" data-testid="footer-termini" className="hover:text-[#FAF9F6] transition-colors">Termini e Condizioni</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
